import { useState } from "react"
import { SearchCategories } from "./SearchCategories";
import { useSearchQuery } from "../../hooks/useSearchQuery";

export const Search = ({ categories = [] }) => {
    const [setQuery] = useSearchQuery();
    const [searchInput, setSearchInput] = useState('');
    const [category, setCategory] = useState('');

    const handleSearchInput = (e) => {
        setSearchInput(e.target.value);
    }

    const handleSearch = (e) => {
        e.preventDefault();
        let obj = {
            [category]: searchInput
        }
        setQuery(obj);
    }

    return (
        <div className="flex flex-col sm:flex-row items-center gap-4 p-4 bg-flyers-charcoal rounded-lg border border-flyers-dark-gray">
            <input
                type="text"
                onChange={handleSearchInput}
                value={searchInput}
                placeholder="Search..."
                className="px-4 py-2 rounded outline-none focus:ring-2 focus:ring-flyers-orange bg-flyers-black text-white border border-flyers-dark-gray placeholder-flyers-mid-gray w-full sm:flex-1"
            />
            <button
                onClick={handleSearch}
                className="bg-flyers-orange text-white font-heading font-bold uppercase tracking-wider px-6 py-2 rounded hover:bg-flyers-orange-light transition-colors duration-150 w-full sm:w-auto"
            >
                Search
            </button>
            <SearchCategories options={categories} setCategory={setCategory} />
        </div>
    )
}
